import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { RegistrationService } from '../services/registration.service';

import { Customer } from '../models/Customer';

@Component({
  selector: 'app-about-you',
  templateUrl: './about-you.component.html',
  styleUrls: ['./about-you.component.css']
})
export class AboutYouComponent implements OnInit {

  customer: Customer;
  // TODO - get this from previous view
  customerUUID: string;
  confirmEmail: string;
  accountNotFound = false;
  customerAlreadyExists = false;
  emailsDontMatch = false;

  constructor(
    private service: RegistrationService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.customer = {
      username: '',
      password: '',
      email: '',
      accountNumber: '',
      accountId: '',
      customerUUID: '',
      webAccessCode: '',
      firstName: '',
      lastName: '',
      lastFourSSN: '',
      zipCode: 0,
      orgUnitId: '',
      userId: '',
      id: '',
      UserUUID: ''
    };
  }

  ngOnInit() {
    this.getAccountID();
  }

  onAboutYouContinueClick() {
    this.spinnerService.show();
    let newCustomer: Customer = {
      accountNumber: this.customer.accountNumber,
      accountId: this.customer.accountId,
      customerUUID: this.customer.customerUUID,
      webAccessCode: this.customer.webAccessCode,
      username: this.customer.username,
      password: this.customer.password,
      email: this.customer.email,
      firstName: this.customer.firstName,
      lastName: this.customer.lastName,
      lastFourSSN: this.customer.lastFourSSN,
      zipCode: this.customer.zipCode,
      orgUnitId: this.customer.orgUnitId,
      userId: this.customer.userId,
      id: this.customer.id,
      UserUUID: this.customer.UserUUID,
    };


    if (newCustomer.email !== this.confirmEmail) {
      this.emailsDontMatch = true;
      this.spinnerService.hide();
      return;
    }

    this.service.registerAboutYou(newCustomer)
      .subscribe((res: any) => {
        if (res.success) {
          this.customer.customerUUID = res.customerUUID;
          this.service.updateCustomerId(this.customer.customerUUID);
          this.service.updateFirstAndLastName(this.customer.firstName, this.customer.lastName);
          this.service.updateEmail(this.customer.email)
          this.mapCustomerToAccount();
        } else {
          this.accountNotFound = true;
          this.spinnerService.hide();
        }
      });
  }

  onCancel() {
    this.router.navigate(['/Login']);
  }

  onBack() {
    this.router.navigate(['/Register']);
  }

  getAccountID() {
    this.service.accountId.subscribe(acctId => this.customer.accountId = acctId);
  }

  mapCustomerToAccount() {
    this.service.mapCustomerToAccount(this.customer)
      .subscribe((res: any) => {
        if (res.success) {
          this.service.updateOrgUnitId(res.orgUnitId);
          this.router.navigate(['/SetPass']);
          this.spinnerService.hide();
        } else {
          this.customerAlreadyExists = true;
          this.spinnerService.hide();
        }
      });;
  }

}



// WEBPACK FOOTER //
// ./src/app/about-you/about-you.component.ts